import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn
} from '@angular/forms';

export class DateValidators {

  static noPastDate(): ValidatorFn {

    return (
      control: AbstractControl
    ): ValidationErrors | null => {

      if (!control.value) {
        return null;
      }

      const selected =
        new Date(control.value);

      const today =
        new Date();

      today.setHours(
        0,0,0,0
      );

      selected.setHours(
        0,0,0,0
      );

      return selected < today
        ? {
            pastDateNotAllowed:true
          }
        : null;
    };
  }

  static noFutureDate(): ValidatorFn {

    return (
      control: AbstractControl
    ): ValidationErrors | null => {

      if (!control.value) {
        return null;
      }

      const selected =
        new Date(control.value);

      const today =
        new Date();

      today.setHours(
        0,0,0,0
      );

      selected.setHours(
        0,0,0,0
      );

      return selected > today
        ? {
            futureDateNotAllowed:true
          }
        : null;
    };
  }
}